// extracted by mini-css-extract-plugin
module.exports = {"productBlock":"RelatedProducts_productBlock__w8lQe","mediaWrapper":"RelatedProducts_mediaWrapper__cCHFC","relatedPostsTitle":"RelatedProducts_relatedPostsTitle__ZQW_R","productTitle":"RelatedProducts_productTitle__9V6fH","productImg":"RelatedProducts_productImg__4kd2r"};
module.exports.__checksum = "dab9e8d81e84"
